import { fetchSidebarConfig } from '@jira/router-resources__sidebar-config/src/fetchSidebarConfig.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import type {
	SidebarConfigData,
	SidebarConfigQuery,
} from '@jira/navigation-apps__shared-types/src/types.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL = 'NAVIGATION_SIDEBAR_GLOBAL';

type DataType = {
	response: SidebarConfigData;
	scope: SidebarConfigQuery;
};
export const navigationSidebarGlobalResource: RouteResource<DataType> = createResource<DataType>({
	type: RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL,
	getKey: ({ match, query }) => {
		// Refresh the data if the project key or id changes
		const { projectKey, projectId } = getProjectKeyId(match, query);
		return projectKey || projectId || '__state';
	},
	getData: async ({ match, query }, _storeContext) => {
		const { projectKey, projectId } = getProjectKeyId(match, query);
		const scope: SidebarConfigQuery = {
			projectKey,
			projectId,
		};
		const response = await fetchSidebarConfig(scope);
		return {
			response,
			scope,
		};
	},
	maxAge: 5 * 60 * 1000,
	isCritical: true,
});
